// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"VX-z","sponsoredTooltipWrapper":"WX-z","sponsoredTooltip":"XX-z","newCard":"YX-z"};